import { PlayerSdk } from "@api.video/player-sdk";
import { type CSSProperties, useEffect, useRef } from "react";
import { useAppTheme } from "../../useAppTheme";

type LayoutDimension = number | string;

type Props = {
	videoUrl: string;
	maxWidth?: LayoutDimension;
	height?: LayoutDimension;
	aspectRatio?: string;
};

export const VideoPlayer = ({
	videoUrl,
	maxWidth = "100%",
	height = 450,
	aspectRatio,
}: Props) => {
	const playerRef = useRef<HTMLDivElement>(null);
	const theme = useAppTheme();
	const isDirectUrl =
		videoUrl.startsWith("http://") || videoUrl.startsWith("https://");
	const containerStyle: CSSProperties = {
		width: "100%",
		maxWidth,
		backgroundColor: theme.colors.backdrop,
		...(aspectRatio ? { aspectRatio } : { height }),
	};

	useEffect(() => {
		if (isDirectUrl || !playerRef.current) {
			return;
		}
		new PlayerSdk(playerRef.current, {
			id: videoUrl,
			hideTitle: true,
		});
		const iframe = playerRef.current.querySelector("iframe");
		if (iframe) {
			iframe.style.border = "0";
			iframe.style.display = "block";
			iframe.style.width = "100%";
			iframe.style.height = "100%";
		}
	}, [videoUrl, isDirectUrl]);

	if (isDirectUrl) {
		return (
			<div style={containerStyle}>
				<video
					src={videoUrl}
					controls
					controlsList="nodownload noremoteplayback noplaybackrate"
					disablePictureInPicture
					onContextMenu={(e) => e.preventDefault()}
					preload="metadata"
					style={{
						width: "100%",
						height: "100%",
						display: "block",
						objectFit: "contain",
						backgroundColor: theme.colors.backdrop,
					}}
				>
					<track kind="captions" />
				</video>
			</div>
		);
	}

	return <div ref={playerRef} style={containerStyle} />;
};
